export const infectiousDiseasesConst = {
  path: "/single-programs/infectious-diseases",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ — ИНФЕКЦИОННЫЕ ЗАБОЛЕВАНИЯ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> магистра
      </p>
      <p>
        <strong>Форма обучения:</strong> очная или дистанционная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <h2>Инфекционные заболевания — защита человечества от глобальных угроз</h2>
      <p>
        Программа подготовки по инфекционным заболеваниям направлена на изучение природы вирусных, бактериальных, грибковых и паразитарных
        инфекций. Студенты осваивают современные методы диагностики, лечения и предотвращения вспышек заболеваний — от гриппа и COVID-19 до
        тропической лихорадки и ВИЧ.
      </p>
      <p>Это ключевая медицинская специальность, играющая важную роль в глобальном здравоохранении и общественной безопасности.</p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Клиническая инфекционистика</li>
        <li>Вирусология, бактериология, паразитология</li>
        <li>Диагностика инфекционных заболеваний</li>
        <li>Эпидемиология и санитарный надзор</li>
        <li>Лечение и профилактика ВИЧ, гепатитов, ТБ</li>
        <li>Тропическая медицина</li>
        <li>Противоэпидемические меры и биобезопасность</li>
        <li>Международные санитарные нормы и регуляции</li>
      </ul>
      <p>Практика проходит в инфекционных стационарах, лабораториях, международных медицинских миссиях и исследовательских центрах.</p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Врач-инфекционист в государственных и частных клиниках</li>
        <li>Эпидемиолог в структурах здравоохранения и международных организациях</li>
        <li>Специалист по ВИЧ/СПИД или гепатитам</li>
        <li>Консультант по тропическим заболеваниям</li>
        <li>Научный сотрудник в области микробиологии и вирусологии</li>
        <li>Эксперт по санитарному контролю и биобезопасности</li>
      </ul>
      <h2>Востребованность и доход</h2>
      <p>Квалифицированные инфекционисты — незаменимые специалисты во времена пандемий и в глобальной системе здравоохранения.</p>
      <p>
        <strong>Средний доход в Европе — от €55,000 до €95,000 в год,</strong> в зависимости от профиля, опыта и региона работы.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом магистра</li>
        <li>Обучение на русском и английском языках</li>
        <li>Дистанционная и очная формы</li>
        <li>Современные лаборатории, симуляционные технологии</li>
        <li>Стажировки в инфекционных клиниках и международных проектах</li>
        <li>Индивидуальное сопровождение студента до трудоустройства</li>
      </ul>
      <h2>Учёба, которая предотвращает эпидемии</h2>
      <p>
        Наши выпускники становятся ключевыми специалистами в системе здравоохранения, участвуют в глобальных программах ВОЗ, работают в
        горячих точках и спасают жизни.
      </p>
      <br />
      <p className="padding-left">«Борьба с инфекциями — это не только медицинская задача, это глобальная миссия.»</p>
      <h2>Как поступить?</h2>
      <p>Оставьте заявку, загрузите документы и получите подробную консультацию приёмной комиссии. Мы подскажем вам следующий шаг.</p>
    </>
  ),
  contentSearch: `
    Диплом: магистра
    Форма обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии

    Инфекционные заболевания — защита человечества от глобальных угроз
    Программа подготовки по инфекционным заболеваниям направлена на изучение природы вирусных, бактериальных, грибковых и паразитарных инфекций. Студенты осваивают современные методы диагностики, лечения и предотвращения вспышек заболеваний — от гриппа и COVID-19 до тропической лихорадки и ВИЧ.
    Это ключевая медицинская специальность, играющая важную роль в глобальном здравоохранении и общественной безопасности.

    Что вы будете изучать?
    • Клиническая инфекционистика
    • Вирусология, бактериология, паразитология
    • Диагностика инфекционных заболеваний
    • Эпидемиология и санитарный надзор
    • Лечение и профилактика ВИЧ, гепатитов, ТБ
    • Тропическая медицина
    • Противоэпидемические меры и биобезопасность
    • Международные санитарные нормы и регуляции
    Практика проходит в инфекционных стационарах, лабораториях, международных медицинских миссиях и исследовательских центрах.


    Кем можно работать после окончания?
    • Врач-инфекционист в государственных и частных клиниках
    • Эпидемиолог в структурах здравоохранения и международных организациях
    • Специалист по ВИЧ/СПИД или гепатитам
    • Консультант по тропическим заболеваниям
    • Научный сотрудник в области микробиологии и вирусологии
    • Эксперт по санитарному контролю и биобезопасности

    Востребованность и доход
    Квалифицированные инфекционисты — незаменимые специалисты во времена пандемий и в глобальной системе здравоохранения.
    Средний доход в Европе — от €55,000 до €95,000 в год, в зависимости от профиля, опыта и региона работы.

    Почему выбирают нас?
    • Европейский диплом магистра
    • Обучение на русском и английском языках
    • Дистанционная и очная формы
    • Современные лаборатории, симуляционные технологии
    • Стажировки в инфекционных клиниках и международных проектах
    • Индивидуальное сопровождение студента до трудоустройства

    Учёба, которая предотвращает эпидемии
    Наши выпускники становятся ключевыми специалистами в системе здравоохранения, участвуют в глобальных программах ВОЗ, работают в горячих точках и спасают жизни.
    «Борьба с инфекциями — это не только медицинская задача, это глобальная миссия.»

    Как поступить?
    Оставьте заявку, загрузите документы и получите подробную консультацию приёмной комиссии. Мы подскажем вам следующий шаг.
  `,
};
